import './PageActionsV2.scss';

import React from 'react';

interface PageActionsProps {
  actions?: React.ReactNode; // Pass actions inside react fragment to not broke styles
}

const PageActionsV2 = ({ actions }: PageActionsProps) => {
  return <div className="PageActionsV2">{actions}</div>;
};

export default PageActionsV2;
